import React, { ReactNode } from "react";

type Props = {
    children: ReactNode;
    display: string;
    close: () => void;
};

const LetsSeeModal: React.FC<Props> = (props: Props) => (
    <div className="lets-see-modal" style={{display:props.display}}>
        <div onClick={props.close} className="close-modal">X &shy; CLOSE</div>
        <span id="modal-img-container">{props.children}</span>
    </div>
);

export default LetsSeeModal;
